import React from 'react';

export default () => (<div className="project" id="project-4">
  <div className="slogan">
    <img src={process.env.PUBLIC_URL + '/images/project/project-4-slogan.png'} alt="镇安县板栗种植及深加工产业化" />
  </div>
  <div className="content">
    <div id="constructions">
      <div className="title">
        <span>建设内容</span>
      </div>
    </div>
    <div id="advantages">
      <div className="title">
        <div className="icon icon-project-advantages"></div>
        <div className="name">项目特色及优势</div>
      </div>
      <div className="advantage">
        <span>规模大、面积大，本项目在镇安县开发5000亩的板栗种植及深加工产业化。</span>
      </div>
      <div className="advantage">
        <span>成立合作社，带动周边农民收入及经济效率。</span>
      </div>
      <div className="advantage">
        <span>技术含量高，组装研究人员开发一批板栗的深加工产品，为提高板栗的附加值提供了多项选择。</span>
      </div>
      <div className="advantage">
        <span>新建大型冷库，为板栗的存储及周边农作物的存储保鲜提供解决办法。</span>
      </div>
      <div className="advantage">
        <span>项目从成立合作社、板栗种植、深加工、存储、销售展示了一整套产业化链条，为陕南林业产业模式提供了借鉴。</span>
      </div>
    </div>
    <div className="background"></div>
  </div>
</div>
);